import { authPost } from "../../common/redux/ApiClient";

const baseUrl = "http://35.240.204.237/w188_api";

export function getPromotionList(queryParams) {
  return authPost(`${baseUrl}/Member6.ashx`, queryParams);
}
